export default {
  experimentId: "43",
  serverUrl: "https://magpie-cogsciprag.fly.dev",
  socketUrl: "wss://magpie-cogsciprag.fly.dev/socket",

  // this will be used in prolific mode
  completionUrl: "https://app.prolific.com/submissions/complete?cc=CK0WQZY1",

  contactEmail: "michael.franke@uni-tuebingen.de",

  // Either 'debug', 'directLink' or 'prolific'
  mode: "prolific",
  language: "en"
};